import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import GenerarAlt from "../../utils/GenerarAlt"
import "./BannerItemStyle3.scss"
import { Link } from "gatsby"

const getGatsbyData = media =>
  media?.sourceUrlSharp?.childImageSharp?.gatsbyImageData || null

const getSrc = media => media?.sourceUrl || null

const BannerItemStyle3 = ({ proyecto }) => {
  const fondoDesktop = proyecto?.estilo3ImagenFondoDesktop
  const principalDesktop = proyecto?.estilo3ImagenPrincipalDesktop
  const fondoMobile = proyecto?.estilo3ImagenFondoMobile
  const principalMobile = proyecto?.estilo3ImagenPrincipalMobile

  const fondoDesktopImg = getGatsbyData(fondoDesktop)
  const principalDesktopImg = getGatsbyData(principalDesktop)
  const fondoMobileImg = getGatsbyData(fondoMobile)
  const principalMobileImg = getGatsbyData(principalMobile)

  return (
    <div className="relative">
      {proyecto?.estilo3BotonTexto && (
        <div className="banner-float-button">
          <Link to={proyecto.estilo3BotonLink} className="banner-boton4">
            {proyecto.estilo3BotonTexto}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 12H20M20 12L16 8M20 12L16 16"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      )}

      <div className="only-desktop style3-banner-item">
        {fondoDesktopImg ? (
          <GatsbyImage
            className="style3-bg-img w-full"
            image={fondoDesktopImg}
            alt={GenerarAlt(fondoDesktop)}
          />
        ) : getSrc(fondoDesktop) ? (
          <img
            className="style3-bg-img w-full"
            src={getSrc(fondoDesktop)}
            alt={GenerarAlt(fondoDesktop)}
            loading="lazy"
          />
        ) : null}

        {principalDesktopImg ? (
          <GatsbyImage
            className="style3-bg-main"
            objectFit="contain"
            image={principalDesktopImg}
            alt={GenerarAlt(principalDesktop)}
          />
        ) : getSrc(principalDesktop) ? (
          <img
            className="style3-bg-main"
            style={{ objectFit: "contain" }}
            src={getSrc(principalDesktop)}
            alt={GenerarAlt(principalDesktop)}
            loading="lazy"
          />
        ) : null}
      </div>

      <div className="only-mov style3-banner-item">
        {fondoMobileImg ? (
          <GatsbyImage
            className="style3-bg-img w-full"
            image={fondoMobileImg}
            alt={GenerarAlt(fondoMobile)}
          />
        ) : getSrc(fondoMobile) ? (
          <img
            className="style3-bg-img w-full"
            src={getSrc(fondoMobile)}
            alt={GenerarAlt(fondoMobile)}
            loading="lazy"
          />
        ) : null}

        {principalMobileImg ? (
          <GatsbyImage
            className="style3-bg-main"
            image={principalMobileImg}
            alt={GenerarAlt(principalMobile)}
          />
        ) : getSrc(principalMobile) ? (
          <img
            className="style3-bg-main"
            src={getSrc(principalMobile)}
            alt={GenerarAlt(principalMobile)}
            loading="lazy"
          />
        ) : null}
      </div>
    </div>
  )
}

export default BannerItemStyle3
